import {
  STORAGE_KEY_LOCALE,
  STORAGE_KEY_RECAPTCHA_V2_FAIL_DATE,
  STORAGE_KEY_USER_ROLES,
} from "@/config/const";

export const LocaleService = {
  init() {
    if (!this.getLocale()) {
      this.setLocale(process.env.VUE_APP_I18N_LOCALE);
    }
  },
  setLocale(locale = "ru") {
    localStorage.setItem(STORAGE_KEY_LOCALE, locale);
  },
  getLocale() {
    return localStorage.getItem(STORAGE_KEY_LOCALE);
  },
};

export const RecaptchaService = {
  setV2FailDate() {
    localStorage.setItem(STORAGE_KEY_RECAPTCHA_V2_FAIL_DATE, `${+new Date()}`);
  },
  getV2FailDate() {
    return localStorage.getItem(STORAGE_KEY_RECAPTCHA_V2_FAIL_DATE);
  },
};

export const UserService = {
  setRoles(roles: string[]) {
    localStorage.setItem(STORAGE_KEY_USER_ROLES, JSON.stringify(roles));
  },
  getRoles(): string[] {
    return JSON.parse(localStorage.getItem(STORAGE_KEY_USER_ROLES) || "[]");
  },
};
